import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

@Injectable()
export class MatPaginatorIntlCro extends MatPaginatorIntl implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private translocoService: TranslocoService) {
    super();
    this.updateLabels();

    // Subscribe to language changes to update labels
    this.translocoService.langChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateLabels();
    });
  }

  private updateLabels(): void {
    this.itemsPerPageLabel = this.translocoService.translate('Items per page:');
    this.nextPageLabel = this.translocoService.translate('Next Page');
    this.previousPageLabel = this.translocoService.translate('Previous Page');
    this.firstPageLabel = this.translocoService.translate('First Page');
    this.lastPageLabel = this.translocoService.translate('Last Page');
    // Trigger change detection to update paginator labels
    this.changes.next();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getRangeLabel = (page, pageSize, length) => {
    if (length === 0 || pageSize === 0) {
      return '0 ' + this.translocoService.translate('of') + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return (
      startIndex + 1 + ' - ' + endIndex + ' ' + this.translocoService.translate('of') + ' ' + length
    );
  };
}
